function SummaryDeltaPositive({ element, value }) {
  let signal = "";

  if (value > 0)
    signal = "+";

  return (
    <div className="text-success">
      ({signal}{element})
    </div>
  )
}

module.exports = SummaryDeltaPositive;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/SummaryDelta/summary-delta-positive.jsx